import actionTypes from './actionTypes';

export const fetch = () => ({
  type: actionTypes.FETCH,
});

export const fetching = () => ({
  type: actionTypes.FETCHING,
});

export const fetched = (currency) => ({
  type: actionTypes.FETCHED,
  payload: {
    currency,
  },
});
